export default "__VITE_ASSET__549Hyf9G__"